import {useEffect, useRef} from 'react';
import {getETicketScanStatus} from '../../../../../redux/eTicket/eTicketActions';
import {TEticketScanStatus} from '../../../../../redux/eTicket/eTicket.type';

const POLL_INTERVAL_MS = 5000;

interface UseQrScanPollOptions {
    token?: string;
    qid: number;
    enabled: boolean;
    onScanned: (scanTs?: number) => void;
}

function isScannedValue(value: TEticketScanStatus['scanned'] | boolean | undefined): boolean {
    return value === 1 || value === true;
}

function useQrScanPoll({token, qid, enabled, onScanned}: UseQrScanPollOptions): void {
    const onScannedRef = useRef(onScanned);
    onScannedRef.current = onScanned;

    useEffect(() => {
        if(!enabled || !token) {
            return;
        }

        let active = true;
        let intervalId = 0;

        const stop = () => {
            active = false;
            window.clearInterval(intervalId);
        };

        const poll = async () => {
            const res: TEticketScanStatus | undefined = await getETicketScanStatus(token, qid);
            if(!active || !res) {
                return;
            }

            if(isScannedValue(res.scanned)) {
                stop();
                onScannedRef.current(res.scanTs);
            }
        };

        poll();
        intervalId = window.setInterval(poll, POLL_INTERVAL_MS);

        return stop;
    }, [enabled, token, qid]);
}

export default useQrScanPoll;
